import { CanActivateFn, Router } from '@angular/router';
import { inject } from '@angular/core';

import { AuthService } from './auth.service';

/**
 * Gates every authenticated route (Implementation Architecture & Sprint Plan §8).
 * Redirects to /login -- the TEST-ONLY "admin"/"admin" screen standing in for the real
 * external Authenticator Service's own login page until that integration happens. Swap
 * this back to '/auth/callback' (still present, untouched) once that's wired up, so real
 * unauthenticated visits hand off to the Authenticator Service instead.
 */
export const authGuard: CanActivateFn = () => {
  const authService = inject(AuthService);
  const router = inject(Router);

  return authService.isAuthenticated() ? true : router.parseUrl('/login');
};
